import { ThemesContent } from '../types';

export const VRPAT: ThemesContent = {
  colors: {
    light: '#FFFFFF',
    copyRightColor: '#4A5969',
    privacyColor: '#1CBE28',
  },
};
